const { validator } = require('./validator');
const inOutFormatDecorator = require('./validator').inOutFormatDecorator;

const relatedJobs = {
    jobTitle: {
        type: 'string',
        presence: false,
        length: {
            maximum: 60
        }
    },
    limit: {
        presence: false,
        numericality: {
            onlyInteger: true
        }
    },

    clientIp: {
        presence: true,
        type: 'Ip',
        length: {
            minimum: 1,
            maximum: 46 // ipv6 address
        }
    }
};

module.exports = {
    relatedJobs: {
        schema: relatedJobs,
        validate: inOutFormatDecorator(validator, relatedJobs)
    }
};
